// extracted by mini-css-extract-plugin
export default {"wrapper":"MissionVision_wrapper__IOz+q","mission":"MissionVision_mission__8jekd","vision":"MissionVision_vision__nqy4W"};